export default __webpack_public_path__ + "static/media/551.356d6e53.png";